export const getCookie = (cookieName: string): string => {
  const prefix = `${cookieName}=`;
  const cookies = document.cookie.split(";");

  for (const cookieEntry of cookies) {
    const cookie = cookieEntry.trimStart();

    if (cookie.startsWith(prefix)) {
      return cookie.substring(prefix.length);
    }
  }

  return "";
};

const setCookie = (cookieName: string, cookieValue: string, _expiresAt: number): void => {
  const maxAge = `max-age=${24 * 60 * 60 * 365}`;
  document.cookie = `${cookieName}=setwcm${cookieValue}ts${Date.now()};${maxAge};path=/`;
};

const extractCategoryTokens = (value: string): string[] => {
  const matches = value.match(/c\d+/g);
  return matches ?? [];
};

const cookieCategoryButtons = document.querySelectorAll<HTMLElement>(".cookie-cat");

cookieCategoryButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const cookieValue = getCookie("waconcookiemanagement");
    const currentValue = cookieValue.split("ts")[0] ?? "";
    const normalizedCurrentValue = currentValue.replace(/^setwcm/, "");
    const selectedCategory = button.dataset.cat ?? "";

    if (normalizedCurrentValue === "min") {
      setCookie("waconcookiemanagement", selectedCategory, Date.now());
    } else {
      const existingCategories = extractCategoryTokens(normalizedCurrentValue);
      const selectedCategories = extractCategoryTokens(selectedCategory);
      const mergedCategories = Array.from(new Set([...existingCategories, ...selectedCategories]));
      setCookie("waconcookiemanagement", mergedCategories.join(""), Date.now());
    }

    window.location.reload();
  });
});